import { X, Plus, Minus, Package } from 'lucide-react';
import { getProductImageUrl } from '../../utils/productImage';
import PosRetailStockHint from './PosRetailStockHint';
import { POS_STOCK_INFORMATIONAL_HINT } from '../../utils/posRetailStockDisplay';

export default function CaisseProductModal({
  produit,
  fmt,
  quantitePanier,
  onClose,
  onAdd,
  onSetQuantite,
}) {
  if (!produit) return null;

  const imageUrl = getProductImageUrl(produit);
  const prix = produit.prixPromo ?? produit.prix;
  const hasPromo = produit.prixPromo != null && produit.prixPromo < produit.prix;
  const disabled = produit.indisponible || produit.desactiveParIngredient;
  const stockDisplay = produit.posStockDisplay;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative aspect-[4/3] bg-slate-100">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={produit.nom}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center text-slate-400">
              <Package className="h-16 w-16 mb-2 opacity-40" />
              <span className="text-sm">Pas de photo</span>
            </div>
          )}
          <button
            type="button"
            onClick={onClose}
            className="absolute top-3 right-3 p-2 rounded-full bg-white/90 shadow-md hover:bg-white"
          >
            <X className="h-5 w-5 text-slate-700" />
          </button>
          {produit.categorie && (
            <span className="absolute bottom-3 left-3 px-3 py-1 rounded-full bg-white/95 text-xs font-semibold text-slate-700 shadow">
              {produit.categorie}
            </span>
          )}
          {disabled && (
            <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-red-500 text-white text-xs font-bold">
              Indisponible
            </span>
          )}
        </div>

        <div className="p-6 overflow-y-auto flex-1">
          <h2 className="text-2xl font-bold text-slate-900">{produit.nom}</h2>
          {produit.description && (
            <p className="text-slate-600 mt-2 text-sm leading-relaxed">{produit.description}</p>
          )}
          <div className="flex items-baseline gap-3 mt-4">
            <span className="text-3xl font-bold text-emerald-600">{fmt(prix)}</span>
            {hasPromo && (
              <span className="text-lg text-slate-400 line-through">{fmt(produit.prix)}</span>
            )}
          </div>
          {stockDisplay?.managed ? (
            <>
              <PosRetailStockHint display={stockDisplay} className="!mt-2 text-sm" />
              <p className="text-[11px] text-slate-400 mt-1 leading-snug">
                {POS_STOCK_INFORMATIONAL_HINT}
              </p>
            </>
          ) : null}
        </div>

        <div className="p-4 border-t border-slate-100 bg-slate-50 flex gap-3">
          {quantitePanier > 0 ? (
            <>
              <div className="flex items-center gap-2 bg-white border-2 border-slate-200 rounded-xl px-2">
                <button
                  type="button"
                  onClick={() => onSetQuantite(-1)}
                  className="p-3 hover:bg-slate-100 rounded-lg"
                >
                  <Minus className="h-5 w-5" />
                </button>
                <span className="w-8 text-center font-bold text-lg">{quantitePanier}</span>
                <button
                  type="button"
                  onClick={() => onSetQuantite(1)}
                  disabled={disabled}
                  className="p-3 hover:bg-slate-100 rounded-lg disabled:opacity-40"
                >
                  <Plus className="h-5 w-5" />
                </button>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="flex-1 py-3.5 rounded-xl bg-emerald-600 text-white font-bold hover:bg-emerald-700"
              >
                Dans le panier
              </button>
            </>
          ) : (
            <button
              type="button"
              onClick={onAdd}
              disabled={disabled}
              className="w-full py-4 rounded-xl bg-emerald-600 text-white font-bold text-lg hover:bg-emerald-700 disabled:opacity-40 flex items-center justify-center gap-2"
            >
              <Plus className="h-6 w-6" />
              {produit.options?.some((o) => o.choix?.length > 0)
                ? 'Choisir les options'
                : 'Ajouter au panier'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
